import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withRouter from '../WithRouter';
import styles from './tabsContainer.module.css';

class TabsContainer extends Component {
  constructor(props) {
    super(props);

    this.renderTitles = this.renderTitles.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.onTabClicked = this.onTabClicked.bind(this);

    const path = this.props.location.pathname;
    const route = path.substr(path.lastIndexOf('/'));
    const selected = this.props.children.findIndex((child) => child.props.route === route);

    this.state = {
      selected: selected !== -1 ? selected : this.props.initialTab,
      routes: this.props.children.map((child) => child.props.route)
    };
  }

  onTabClicked(index, event) {
    event.preventDefault();
    this.updateRoute(index);
    this.setState({ selected: index });
  }

  updateRoute(index) {
    const currentTabRoute = this.props.children[index].props.route;
    const { pathname } = this.props.location;
    const previousTabRoute = this.state.routes.find((route) => route !== '' && pathname.endsWith(route)) || '';

    if (currentTabRoute !== previousTabRoute) {
      this.props.navigate(`${pathname.replace(previousTabRoute, '')}${currentTabRoute}`);
    }
  }

  renderTitles() {
    const childCount = this.props.children.length;
    const getPositionClass = (index) => {
      if (index === 0) {
        return 'first';
      } if (index === childCount - 1) {
        return 'last';
      }
      return '';
    };

    const label = (child, index) => {
      const selectedClass = this.state.selected === index ? `selected ${styles.selected}` : '';
      const positionClass = getPositionClass(index);
      return (
        <li
          key={index}
          className={`horizontal-tab-button horizontal-tab-button-${index} ${selectedClass} ${positionClass} ${styles.tab}`}
        >
          <button
            type="button"
            className={`${styles.tabButton} ${this.props.skinny ? styles.tabButtonSkinny : ''}`}
            onClick={(event) => this.onTabClicked(index, event)}
          >
            {
              (child.props.icon)
                ? (<span className={`icon-2x ${styles.tabButtonIcon} ${child.props.icon}`} />)
                : ''
            }
            <span className={styles.tabButtonLabel}>{child.props.label}</span>
          </button>
        </li>
      );
    };

    return (
      <ul className={`${this.props.skinny ? styles.tabListSkinny : ''} horizontal-tabs-list`} data-cy="horizontal-tab-list">
        {this.props.children.map(label)}
      </ul>
    );
  }

  renderContent() {
    return this.props.children[this.state.selected];
  }

  render() {
    return (
      <div className="horizontal-tabs clearfix">
        {this.renderTitles()}
        {this.renderContent()}
      </div>
    );
  }
}

const {
  element, arrayOf, oneOfType, number, shape, func, string, bool
} = PropTypes;
TabsContainer.propTypes = {
  children: oneOfType([element, arrayOf(element)]).isRequired,
  initialTab: number,
  location: shape({
    pathname: string
  }).isRequired,
  navigate: func.isRequired,
  skinny: bool
};

TabsContainer.defaultProps = {
  initialTab: 0,
  skinny: false
};

export default withRouter(TabsContainer);
